/**
 * Truncate option desc for Yes/No display: 6+ chars → first 4 chars + ellipsis.
 */
export function truncateOptionDesc( desc: string ): string {
    const s = String( desc ?? "" );
    return s.length >= 6 ? s.slice( 0, 4 ) + "..." : s;
}
